import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export const getShippingAndTaxDisclaimerMap = (t: (key: string) => string) => ({
  [ShopifyStore.IN]: null,
  [ShopifyStore.US]: t('sharedCart.shippingAndTaxDisclaimer.us'),
  [ShopifyStore.AE]: t('sharedCart.shippingAndTaxDisclaimer.ae'),
  [ShopifyStore.ROW]: t('sharedCart.shippingAndTaxDisclaimer.row'),
  [ShopifyStore.GB]: t('sharedCart.shippingAndTaxDisclaimer.row'),
  [ShopifyStore.EU]: t('sharedCart.shippingAndTaxDisclaimer.row'),
  [ShopifyStore.AU]: t('sharedCart.shippingAndTaxDisclaimer.row'),
  [ShopifyStore.CA]: t('sharedCart.shippingAndTaxDisclaimer.us'),
  [ShopifyStore.SA]: t('sharedCart.shippingAndTaxDisclaimer.row'),
  [ShopifyStore.MX]: t('sharedCart.shippingAndTaxDisclaimer.row'),
  [ShopifyStore.ZA]: t('sharedCart.shippingAndTaxDisclaimer.row'),
  [ShopifyStore.JP]: t('sharedCart.shippingAndTaxDisclaimer.row'),
});

/** Inline tax label replaces the old shipping/tax disclaimer line (not shown for IN). */
export const shouldShowInlineCartTaxLabel = (
  store: ShopifyStore | null | undefined,
  t: (key: string) => string,
): boolean => {
  if (!store) return false;
  return getShippingAndTaxDisclaimerMap(t)[store as ShopifyStore] !== null;
};

export const cartContentVars = `
  --seperator-border: 1px solid rgba(0,0,0,0.1);
  --button-radius: 16px;
  --internal-sections-padding: 6px 16px;
  --footer-sections-padding: 20px 24px 16px;
`;
